<template>
  <div>
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/user">利用者一覧</router-link>
            </li>
            <li class="breadcrumb-item active">利用者</li>
          </ol>
        </div>
      </div>
      <div class="row" v-if="Object.keys(errors).length > 0">
        <div class="col-md-12">
          <div class="alert alert-warning">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <ul>
              <li v-for="(error, field) in errors" :key="field">
                {{ error }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-outline-info">
            <div class="card-header">
              <h4 class="m-b-0 text-white">利用者</h4>
            </div>
            <div class="card-body">
              <form @submit.prevent="onSubmit" class="form" :disabled="!isLoaded">
                <div class="form-body">
                  <h3 class="box-title">管理事業所</h3>
                  <hr class="m-t-0 m-b-10">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group">
                        <label class="control-label">事業所</label>
                        <v-select name="office" :multiple="true"
                                  :options="offices"
                                  v-model="inputs.offices"/>
                      </div>
                    </div>
                  </div>
                  <h3 class="box-title">個人情報</h3>
                  <hr class="m-t-0 m-b-10">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group" :class="{'has-danger': errors.display_name }">
                        <label class="control-label">氏名</label>
                        <div class="text-danger">※必須項目</div>
                        <input type="text"
                               class="form-control"
                               maxlength="30"
                               v-model="inputs.display_name"
                               @blur="validateField('display_name')">
                        <div class="text-danger">※注意：氏名の変更は既存の報告内容などにも反映されます。</div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group row">
                        <label class="control-label">フリガナ</label>
                        <input type="text"
                               class="form-control"
                               maxlength="60"
                               v-model="inputs.display_name_kana" >
                      </div>
                    </div>
                    <div class="col-md-2" v-if="qrcodeUrl">
                      <div class="form-group row">
                        <a :href="qrcodeUrl" target="_blank">
                          <img :src="qrcodeUrl" width="100" height="100"/>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group" :class="{'has-danger': errors.sex_cd }">
                        <label class="control-label">性別</label>
                        <div class="text-danger">※必須項目</div>
                        <select-code
                          :code-group="SEX_CODES"
                          v-model="inputs.sex_cd"
                          @blur="validateField('sex_cd')"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="control-label">生年月日</label>
                        <div class="input-group">
                          <input class="form-control"
                                 type="date"
                                 v-model="inputs.birthday"
                                 @blur="validateField('birthday')">
                          <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary"
                                    @click="showJapaneseCalendar">和暦
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group" :class="{'has-danger': errors.external_id }">
                        <label class="control-label">請求ソフト連携ID</label>
                        <input type="text"
                               class="form-control"
                               v-model="inputs.external_id">
                               <!-- @blur="validateField('external_id')"> -->
                      </div>
                    </div>
                  </div>
                  <ul class="nav nav-tabs customtab" role="tablist">
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        :class="{ 'active': activeTab === 'address' }"
                        @click.prevent="activeTab = 'address'"
                        href="#address"
                        role="tab"
                      >
                        <span>連絡先</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        :class="{ 'active': activeTab === 'emg_address' }"
                        @click.prevent="activeTab = 'emg_address'"
                        href="#emg_address"
                        role="tab"
                      >
                        <span>緊急連絡先</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        :class="{ 'active': activeTab === 'billing_address' }"
                        @click.prevent="activeTab = 'billing_address'"
                        href="#billing_address"
                        role="tab"
                      >
                        <span>請求先</span>
                      </a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div
                      class="tab-pane p-3"
                      :class="{ 'active': activeTab === 'address' }"
                      id="address"
                      role="tabpanel"
                    >
                      <address-edit display-name="連絡先" name="address" v-model="inputs.address"/>
                    </div>
                    <div
                      class="tab-pane p-3"
                      :class="{ 'active': activeTab === 'emg_address' }"
                      id="emg_address"
                      role="tabpanel"
                    >
                      <address-edit display-name="緊急連絡先" name="emg_address" :with-display-name="true"
                                    v-model="inputs.emg_address"/>
                    </div>
                    <div
                      class="tab-pane p-3"
                      :class="{ 'active': activeTab === 'billing_address' }"
                      id="billing_address"
                      role="tabpanel"
                    >
                      <address-edit display-name="請求先" name="billing_address" :with-display-name="true"
                                    v-model="inputs.billing_address"/>
                    </div>
                  </div>
                </div>
                <div class="form-actions">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <router-link to="/user">キャンセル</router-link>
                      <span class="mx-2"></span>
                      <button type="button" class="action-button btn btn-danger btn-rounded"
                              @click="remove"
                              :disabled="!isLoaded"
                              v-if="id">
                        削除する
                      </button>
                      <button type="submit" class="action-button btn btn-success btn-rounded"
                              :disabled="!isLoaded">
                        保存する
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-modal v-model="isProcessing" message="更新中..."/>
    <BModal
      v-model="showDeleteModal"
      title="確認"
      @ok="confirmDelete"
      ok-title="はい"
      cancel-title="キャンセル"
      ok-variant="danger"
    >
      <p>削除してもよろしいですか？</p>
    </BModal>
    <!-- Japanese Calendar Modal -->
    <VueFinalModal
      v-model="showJapaneseCalendarModal"
      classes="modal-container"
      content-class="modal-content"
      :click-to-close="true"
    >
      <japanese-calendar-modal
        v-model="inputs.birthday"
        @close="showJapaneseCalendarModal = false"
      />
    </VueFinalModal>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import _ from 'underscore'
import api from '../../libs/Api'
import utils from '../../libs/Utils'
import Constants from '../../constants'
import SelectCode from '../../components/SelectCode'
import AddressEdit from '../../components/AddressEdit'
import LoadingModal from '../../components/LoadingModal'
import JapaneseCalendarModal from '../../components/JapaneseCalendarModal'
import { BModal } from 'bootstrap-vue-next'
import { useToast } from 'vue-toastification'
import { VueFinalModal } from 'vue-final-modal'
import * as yup from 'yup'

const router = useRouter()
const route = useRoute()
const store = useStore()
const toast = useToast()

// Constants
const Code = computed(() => Constants.Code || {})
const SEX_CODES = computed(() => Code.value?.SEX || {})

// State
const id = ref(null)
const offices = ref([])
const isLoaded = ref(false)
const isProcessing = ref(false)
const user = ref(null)
const showDeleteModal = ref(false)
const showJapaneseCalendarModal = ref(false)
const errors = ref({})
const activeTab = ref('address')

// Validation schema
const validationSchema = yup.object({
  display_name: yup.string().trim().required('氏名を入力してください。'),
  sex_cd: yup.string().required('性別を入力してください。')
  // external_id: yup.string()
})

const inputs = ref({
  external_id: '',
  display_name: '',
  display_name_kana: '',
  sex_cd: '',
  birthday: '',
  address: {
    display_name: null,
    postal_code: null,
    prefecture_cd: null,
    addr1: null,
    addr2: null,
    tel1: null,
    tel2: null,
    fax: null,
    email: null
  },
  emg_address: {
    display_name: null,
    postal_code: null,
    prefecture_cd: null,
    addr1: null,
    addr2: null,
    tel1: null,
    tel2: null,
    fax: null,
    email: null
  },
  billing_address: {
    display_name: null,
    postal_code: null,
    prefecture_cd: null,
    addr1: null,
    addr2: null,
    tel1: null,
    tel2: null,
    fax: null,
    email: null
  },
  offices: []
})

// Computed
const qrcodeUrl = computed(() => {
  if (!user.value || !user.value.qrcodes?.length) return null
  return process.env.VUE_APP_FILE_URL + user.value.qrcodes[0].filename
})

const validateField = async (fieldName) => {
  try {
    await validationSchema.validateAt(fieldName, inputs.value)
    delete errors.value[fieldName]
  } catch (error) {
    errors.value[fieldName] = error.message
  }
}

const validateForm = async () => {
  try {
    await validationSchema.validate(inputs.value, { abortEarly: false })
    errors.value = {}
    return true
  } catch (error) {
    const newErrors = {}
    error.inner.forEach(err => {
      newErrors[err.path] = err.message
    })
    errors.value = newErrors
    return false
  }
}

const convertUser2Inputs = (user) => {
  return {
    external_id: user.external_id,
    display_name: user.display_name,
    display_name_kana: user.display_name_kana,
    sex_cd: user.sex_cd,
    birthday: utils.formatDay(user.birthday),
    address: _.clone(user.address),
    emg_address: _.clone(user.emg_address),
    billing_address: _.clone(user.billing_address),
    offices: _.map(user.offices, (office) => {
      return { value: office.id, label: office.display_name }
    })
  }
}

const convertInputs2User = (inputs) => {
  return {
    external_id: inputs.external_id,
    display_name: inputs.display_name,
    display_name_kana: inputs.display_name_kana,
    sex_cd: inputs.sex_cd,
    birthday: inputs.birthday ? inputs.birthday.replace(/-/g, '') : '',
    address: _.clone(inputs.address),
    emg_address: _.clone(inputs.emg_address),
    billing_address: _.clone(inputs.billing_address),
    offices: _.map(inputs.offices, (office) => {
      return { id: office.value }
    })
  }
}

const remove = () => {
  showDeleteModal.value = true
}

const confirmDelete = async () => {
  try {
    await api.deleteUser(id.value)
    toast.success('削除しました。')
    router.push('/user')
  } catch (error) {
    console.error('Error deleting user:', error)
    toast.error('削除に失敗しました。')
  }
}

const showJapaneseCalendar = () => {
  showJapaneseCalendarModal.value = true
}

const onSubmit = async () => {
  try {
    const isValid = await validateForm()
    if (!isValid) return

    isProcessing.value = true
    const params = convertInputs2User(inputs.value)
    let res

    if (id.value) {
      res = await api.putUser(id.value, params)
    } else {
      res = await api.postUser(params)
    }

    if (res) {
      toast.success('保存しました。')
      inputs.value = convertUser2Inputs(res)
      id.value = res.id
      router.push(`/user/${id.value}`)
    }
  } catch (error) {
    console.error('Error saving user:', error)
    toast.error('削除に失敗しました。')
  } finally {
    isProcessing.value = false
  }
}

// Lifecycle hooks
onMounted(async () => {
  try {
    id.value = route.params.id
    const officesData = await store.dispatch('office/getOffices')

    offices.value = officesData.map(office => ({
      label: office.display_name,
      value: office.id
    }))

    if (offices.value.length === 1) {
      inputs.value.offices = offices.value
    }

    if (!id.value) {
      isLoaded.value = true
      return
    }

    const userData = await api.findUser(id.value)
    user.value = userData
    inputs.value = convertUser2Inputs(userData)
    isLoaded.value = true
  } catch (error) {
    console.error('Error initializing component:', error)
    toast.error('データの読み込みに失敗しました。')
  }
})
</script>

<style scoped>
.control-label {
  display: inline-block;
}

.text-danger {
  display: inline-block;
  padding-left: 10px;
}

/* Add styles for validation */
.has-danger input,
.has-danger select {
  border-color: #dc3545;
}

.form-group {
  margin-bottom: 1rem;
}

.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
</style>
